module.exports = __webpack_public_path__ + "img/OVCA_Mast.f3ddec8d.png";